import { SxProps, Theme } from '@mui/material/styles';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const attributesContainerSx: SxProps<Theme> = {
	pt: '20px',
};

export const AttributeSx = (disabled: boolean, selected: boolean) => ({
	p: '10px',
	border: disabled ? '2px dashed' : '2px solid',
	borderColor: disabled ? 'grey.100' : 'grey.500',
	bgcolor: selected ? 'grey.500' : 'white',
	color: selected ? 'white' : disabled ? 'grey.100' : 'grey.500',
	cursor: disabled ? 'default' : 'pointer',
	borderRadius: '3px',
});

export const attributeSx: Record<string, SxProps<Theme>> = {
	text: {
		'&:hover': { textDecoration: { md: 'underline' } },
		fontWeight: OpenSansFontWeights.semibold,
	},
	container: {
		borderRadius: '3px',
		border: '1px solid',
		borderColor: 'grey.50',
		p: '10px',
	},
	hidden: {
		display: 'none',
	},
	label: {
		color: 'grey.500',
		fontWeight: OpenSansFontWeights.semibold,
	},
	value: {
		color: 'grey.200',
	},
	optionsContainer: {
		display: 'flex',
		gap: '10px',
		flexDirection: 'row',
		pt: '10px',
		flexWrap: 'wrap',
	},
};
